import React from "react";
import { FaTasks, FaMoneyBillAlt, FaRss } from "react-icons/fa";
import "./Card.scss";
import { withDefaults } from "../../../utils/withDefaults";

export interface CardProps {
  /** Which of the three built-in illustrations to show. */
  icon?: "PRODUCTIVITY" | "MONEY" | "NEWS";
  title?: string;
  body?: string;
  children?: React.ReactNode;
}

export default function Card(incomingProps: CardProps) {
  const props = withDefaults(incomingProps, cardDefaultProps);

  const getIcon = () => {
    switch (props.icon) {
      case "PRODUCTIVITY":
        return (
          <FaTasks
            className="card-icon"
            size={30}
            aria-label="Productivity Tools icon"
          />
        );
      case "MONEY":
        return (
          <FaMoneyBillAlt
            className="card-icon"
            size={30}
            aria-label="Finance icon"
          />
        );
      case "NEWS":
        return <FaRss className="card-icon" size={30} aria-label="News icon" />;
      default:
        return null;
    }
  };

  return (
    <div className="card">
      {getIcon()}
      <h1>{props.title}</h1>
      {props.children}
    </div>
  );
}

const cardDefaultProps = {
  title: "",
  body: ""
};
